import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionCeseTRADEByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionCeseTRADEByUser = () => {
  const [loadingGetDeclaracionCeseTRADEByUser, setLoadingGetDeclaracionCeseTRADEByUser] = useState(false);
  const [successGetDeclaracionCeseTRADEByUser, setSuccessGetDeclaracionCeseTRADEByUser] = useState(false);
  const [errorGetDeclaracionCeseTRADEByUser, setErrorGetDeclaracionCeseTRADEByUser] = useState<any>(null);
  const [dataGetDeclaracionCeseTRADEByUser, setDataDeclaracionCeseTRADEByUser] = useState<any>(null);

  const [statusGetDeclaracionCeseTRADEByUser, setStatusGetDeclaracionCeseTRADEByUser] =
    useState<StatusGetDeclaracionCeseTRADEByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionCeseTRADEByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionCeseTRADEByUser(true);
    setSuccessGetDeclaracionCeseTRADEByUser(false);
    setErrorGetDeclaracionCeseTRADEByUser(null);

    try {
      const res = await apirecord.getSolicitudDeclaracionJuradaTradeByUser(userId, expedienteId);

      setStatusGetDeclaracionCeseTRADEByUser({
        status: res.status,
        statusText: res.statusText
      });

      setDataDeclaracionCeseTRADEByUser(res.data);
      setSuccessGetDeclaracionCeseTRADEByUser(true);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionCeseTRADEByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionCeseTRADEByUser(err);
      console.error("Error en getDeclaracionCeseTRADEByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionCeseTRADEByUser(false);
    }
  };

  return {
    getDeclaracionCeseTRADEByUser,
    loadingGetDeclaracionCeseTRADEByUser,
    successGetDeclaracionCeseTRADEByUser,
    errorGetDeclaracionCeseTRADEByUser,
    dataGetDeclaracionCeseTRADEByUser,
    statusGetDeclaracionCeseTRADEByUser
  };
};

export default useGetDeclaracionCeseTRADEByUser;